<script setup lang="ts">
import {computed} from 'vue';
import {useRoute} from "vue-router";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import EntidadesLayout from "@/layouts/EntidadesLayout.vue";

const route = useRoute();

const layout = computed( () => {
  const layout = route?.meta?.layout;
  if (layout) {
    return DashboardLayout;
  } else {
    return EntidadesLayout;
  }
});

</script>

<template>
  <component :is="layout">
    <slot></slot>
  </component>
</template>